export default __webpack_public_path__ + "static/media/0074.87565891.jpg";